
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import TabBar from '../../components/layout/TabBar';

const services = [
  {
    id: 1,
    name: 'تمريض منزلي',
    icon: 'ri-nurse-line',
    color: 'from-[#1565C0] to-[#1976D2]',
    image: 'https://public.readdy.ai/ai/img_res/0218b70ddcc676a710bca46bd8a5503a.jpg'
  },
  {
    id: 2,
    name: 'تنظيف',
    icon: 'ri-brush-line',
    color: 'from-[#2E7D32] to-[#43A047]',
    image: 'https://readdy.ai/api/search-image?query=Professional%20cleaning%20service%20worker%20in%20uniform%20cleaning%20modern%20home%20interior%2C%20cleaning%20supplies%20and%20equipment%2C%20bright%20clean%20space%2C%20high%20quality%20photography%2C%20realistic%20style%2C%20fresh%20atmosphere&width=400&height=300&seq=cleaning1&orientation=landscape'
  },
  {
    id: 3,
    name: 'سباكة',
    icon: 'ri-drop-line',
    color: 'from-[#0277BD] to-[#0288D1]',
    image: 'https://readdy.ai/api/search-image?query=Professional%20plumber%20fixing%20pipes%20and%20faucets%20in%20modern%20bathroom%2C%20plumbing%20tools%20visible%2C%20clean%20workspace%2C%20high%20quality%20photography%2C%20realistic%20style%2C%20professional%20service&width=400&height=300&seq=plumbing1&orientation=landscape'
  },
  {
    id: 4,
    name: 'كهرباء',
    icon: 'ri-flashlight-line',
    color: 'from-[#F57C00] to-[#FB8C00]',
    image: 'https://readdy.ai/api/search-image?query=Professional%20electrician%20working%20on%20electrical%20panel%20and%20wiring%20in%20modern%20home%2C%20electrical%20tools%20and%20equipment%2C%20safety%20gear%2C%20high%20quality%20photography%2C%20realistic%20style%2C%20professional%20service&width=400&height=300&seq=electrical1&orientation=landscape'
  },
  {
    id: 5,
    name: 'صيانة أجهزة',
    icon: 'ri-tools-line',
    color: 'from-[#6A1B9A] to-[#7B1FA2]',
    image: 'https://readdy.ai/api/search-image?query=Professional%20technician%20repairing%20home%20appliances%20like%20washing%20machine%20and%20refrigerator%2C%20repair%20tools%20visible%2C%20modern%20home%20setting%2C%20high%20quality%20photography%2C%20realistic%20style%2C%20expert%20service&width=400&height=300&seq=maintenance1&orientation=landscape'
  },
  {
    id: 6,
    name: 'خدمات عاجلة',
    icon: 'ri-alarm-warning-line',
    color: 'from-[#C62828] to-[#D32F2F]',
    image: 'https://readdy.ai/api/search-image?query=Emergency%20home%20service%20response%20team%20ready%20for%20urgent%20repairs%2C%20emergency%20equipment%20and%20tools%2C%20fast%20response%20concept%2C%20high%20quality%20photography%2C%20realistic%20style%2C%20urgent%20service&width=400&height=300&seq=urgent1&orientation=landscape'
  }
];

const popularServices = [
  { id: 1, name: 'تعقيم منازل', icon: 'ri-shield-check-line', price: '150' },
  { id: 2, name: 'صيانة مكيفات', icon: 'ri-temp-cold-line', price: '200' },
  { id: 3, name: 'كشف تسربات', icon: 'ri-water-flash-line', price: '180' },
  { id: 4, name: 'تركيب ثريات', icon: 'ri-lightbulb-line', price: '120' }
];

export default function Home() {
  const navigate = useNavigate();
  const [searchQuery, setSearchQuery] = useState('');
  const isGuest = localStorage.getItem('isGuest') === 'true';

  return (
    <div className="min-h-screen bg-[#F6F6F6] pb-20">
      {/* Header */}
      <div className="bg-gradient-to-br from-[#1565C0] to-[#2E7D32] pt-12 pb-8 px-6 rounded-b-[30px] shadow-lg">
        <div className="flex items-center justify-between mb-6 animate-fadeIn">
          <div>
            <h1 className="text-2xl font-bold text-white">مرحباً بك</h1>
            <p className="text-white/80 text-sm mt-1">
              {isGuest ? '🎭 وضع الزائر' : 'كيف يمكننا مساعدتك اليوم؟'}
            </p>
          </div>
          <button className="w-10 h-10 bg-white/20 rounded-full flex items-center justify-center">
            <i className="ri-notification-3-line text-white text-xl"></i>
          </button>
        </div>

        {/* Search Bar */}
        <div className="bg-white rounded-2xl p-3 flex items-center gap-3 shadow-md animate-slideUp">
          <i className="ri-search-line text-gray-400 text-xl"></i>
          <input
            type="text"
            value={searchQuery}
            onChange={(e) => setSearchQuery(e.target.value)}
            placeholder="ابحث عن خدمة..."
            className="flex-1 outline-none text-sm text-[#212121]"
          />
          <button className="w-8 h-8 bg-[#1565C0] rounded-xl flex items-center justify-center">
            <i className="ri-equalizer-line text-white"></i>
          </button>
        </div>
      </div>

      {/* Main Services */}
      <div className="px-6 mt-6">
        <div className="flex items-center justify-between mb-4 animate-fadeIn">
          <h2 className="text-lg font-bold text-[#212121]">الخدمات الرئيسية</h2>
          <button 
            onClick={() => navigate('/services')}
            className="text-[#1565C0] text-sm font-semibold"
          >
            عرض الكل
          </button>
        </div>

        <div className="grid grid-cols-2 gap-4" data-product-shop>
          {services.map((service, index) => (
            <div
              key={service.id}
              onClick={() => navigate(`/service/${service.id}`)}
              className="bg-white rounded-2xl overflow-hidden shadow-md hover:shadow-lg transition-all active:scale-[0.98] animate-slideUp cursor-pointer"
              style={{ animationDelay: `${index * 0.1}s` }}
            >
              <div className="relative h-32 overflow-hidden">
                <img
                  src={service.image}
                  alt={service.name}
                  className="w-full h-full object-cover object-top"
                />
                <div className={`absolute inset-0 bg-gradient-to-t ${service.color} opacity-20`}></div>
              </div>
              <div className="p-3">
                <div className="flex items-center gap-2">
                  <div className={`w-8 h-8 bg-gradient-to-br ${service.color} rounded-lg flex items-center justify-center`}>
                    <i className={`${service.icon} text-white text-sm`}></i>
                  </div>
                  <h3 className="font-semibold text-[#212121] text-sm">{service.name}</h3>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* Special Offers */}
      <div className="px-6 mt-8">
        <h2 className="text-lg font-bold text-[#212121] mb-4 animate-fadeIn">عروض خاصة</h2>
        <div className="bg-gradient-to-l from-[#FBC02D] to-[#F9A825] rounded-2xl p-5 shadow-lg animate-slideUp relative overflow-hidden">
          <div className="absolute top-0 left-0 w-32 h-32 bg-white/10 rounded-full -translate-x-10 -translate-y-10"></div>
          <div className="absolute bottom-0 right-0 w-24 h-24 bg-white/10 rounded-full translate-x-10 translate-y-10"></div>
          <div className="relative">
            <div className="flex items-center gap-2 mb-2">
              <i className="ri-gift-line text-white text-2xl"></i>
              <span className="bg-white text-[#F9A825] text-xs font-bold px-2 py-1 rounded-full">خصم 30%</span>
            </div>
            <h3 className="text-white font-bold text-lg mb-1">عرض الأسبوع</h3>
            <p className="text-white/90 text-sm mb-3">خصم على جميع خدمات التنظيف</p>
            <button className="bg-white text-[#F9A825] px-4 py-2 rounded-xl text-sm font-semibold hover:bg-white/90 transition-all">
              احجز الآن
            </button>
          </div>
        </div>
      </div>

      {/* Popular Services */}
      <div className="px-6 mt-8 pb-4">
        <h2 className="text-lg font-bold text-[#212121] mb-4 animate-fadeIn">الخدمات الشائعة</h2>
        <div className="grid grid-cols-2 gap-3">
          {popularServices.map((service, index) => (
            <div
              key={service.id}
              onClick={() => navigate(`/service/${service.id}`)}
              className="bg-white rounded-xl p-4 shadow-sm hover:shadow-md transition-all active:scale-[0.98] animate-slideUp cursor-pointer"
              style={{ animationDelay: `${index * 0.1}s` }}
            >
              <div className="w-10 h-10 bg-[#1565C0]/10 rounded-lg flex items-center justify-center mb-2">
                <i className={`${service.icon} text-[#1565C0] text-lg`}></i>
              </div>
              <h3 className="font-semibold text-[#212121] text-sm mb-1">{service.name}</h3>
              <div className="flex items-center gap-1">
                <span className="text-[#1565C0] font-bold text-sm">{service.price}</span>
                <span className="text-gray-400 text-xs">ر.س</span>
              </div>
            </div>
          ))}
        </div>
      </div>

      <TabBar />
    </div>
  );
}
